<template>
    <div class="tabs-body">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        name: 'LiFaTabsBody'
    }
</script>
<style lang="scss" scpoed>
    
</style>